module.exports = __webpack_public_path__ + "img/ips.15687e6e.jpg";